/* import router from './../../router' */
import { store } from './../../store/store'
import axios from 'axios'

export function authAxios () {
  return axios.create({
    headers: {
      'Authorization': `Bearer ${store.getters.getToken}`,
      'Content-Type': 'application/json'
    }
  })
}

// export function authAxiosDownload () {
//   return axios.create({
//     headers: {
//       'Authorization': `Bearer ${store.getters.getToken}`,
//       'Content-Type': 'application/json'
//     }
//   })
// }



// WEBPACK FOOTER //
// ./src/bibliotecas/seguranca/authAxios.js